import { render } from "./DeleteFolderModal.vue?vue&type=template&id=459213cd&scoped=true&ts=true"
import script from "./DeleteFolderModal.vue?vue&type=script&lang=ts"
export * from "./DeleteFolderModal.vue?vue&type=script&lang=ts"

import "./DeleteFolderModal.vue?vue&type=style&index=0&id=459213cd&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-459213cd"]])

export default __exports__